import { ApprovalCategoryBase } from './base/approval-category-base';

export class ApprovalCategory extends ApprovalCategoryBase { }